module.exports = __webpack_public_path__ + "img/emoticon-2120024_960_720.ca4013c5.png";